import { reactive, ref, watch } from "@vue/composition-api";
import Model from "@/models/admin/school-wx-users";
import helpers from "@/utils/helpers";

export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择微信用户"
    },
    value: {
      type: [String, Number, Array],
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    },
    schoolId: {
      type: Number,
      default: 0
    }
  },
  setup(props, context) {
    const cSelect = reactive({
      loading: false,
      value: undefined
    });

    const list = ref({
      items: []
    });

    const getList = async ({ id = "", nickName = "" } = {}) => {
      cSelect.loading = true;

      const { data } = await new Model().addPath("actions/search").GET({
        query: { schoolId: props.schoolId, id, nickName }
      });

      cSelect.loading = false;

      return data;
    };

    watch(
      () => props.value,
      async newVal => {
        if (newVal === 0) {
          list.value = await getList();
        } else if (newVal) {
          list.value = await getList({ id: newVal });
          cSelect.value = props.multiple ? helpers.deepCopy(newVal) : newVal;
        }
      },
      { immediate: true, deep: true }
    );

    const renderList = async query => {
      list.value = await getList({ nickName: query || "" });
    };

    const onChange = value => {
      context.emit("change", value);
    };

    return {
      list,
      cSelect,
      renderList,
      onChange
    };
  }
};
